import React from 'react'
import injectSheet from 'react-jss'
import { TextButton } from '../../'

const Modal = (props) => {
  const {
    action,
    actionName,
    classes,
    closeModal,
    closeModalText = 'abbrechen',
    info,
    text,
    title,
  } = props

  const stopPropagation = (event) => {
    event.stopPropagation()
  }

  return (
    <div
      className={`${classes.modalBackground} ${info && 'info'}`}
      role="button"
      tabIndex={0}
      onClick={closeModal}
      onKeyDown={closeModal}
    >
      <div
        className={`${classes.modalContainer}`}
        role="button"
        tabIndex={0}
        onClick={event => stopPropagation(event)}
        onKeyDown={() => false}
      >
        <h2>{title}</h2>
        <p>{text}</p>
        <div className={`${classes.actions}`}>
          <TextButton
            index={0}
            handleClick={() => closeModal()}
            text={closeModalText}
          />
          {action && (
            <TextButton
              index={0}
              handleClick={() => {
                action()
                closeModal()
              }}
              primary
              text={actionName}
            />
          )}
        </div>
      </div>
    </div>
  )
}

const styles = theme => ({
  modalBackground: {
    position: 'fixed',
    top: 0,
    left: 0,
    height: '100vh',
    width: '100vw',
    zIndex: 101,
    padding: `${theme.sizes.gutter / 2}px`,
    backgroundColor: 'rgba(0,0,0, 0.5)',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    '&.info $modalContainer': {
      borderColor: theme.colors.secondary_3b,
    },
  },
  modalContainer: {
    padding: `${theme.sizes.gutter}px`,
    backgroundColor: theme.colors.main_2,
    width: '100%',
    maxWidth: `${theme.sizes.smallContainer}px`,
    cursor: 'initial',
    borderWidth: '5px',
    borderColor: theme.colors.main_1,
    borderStyle: 'solid',
    borderRadius: '10px',
    color: theme.colors.secondary_3c,
  },
  actions: {
    display: 'flex',
    justifyContent: 'flex-end',
    width: '100%',
  },
})

export default injectSheet(styles)(Modal)



// WEBPACK FOOTER //
// ./src/modules/core/components/modal.jsx